import { Box } from "@material-ui/core"
import { Reply } from "@material-ui/icons"

export const ReplyButton = ({
  onClick
}: {
  onClick: () => void
}) => {
  return (
    <Box onClick={onClick}>
      <Box
        paddingTop={'2px'}
        fontWeight={'bold'}>
        <span>
          <Reply style={{
            fontSize: 10
          }} />
        </span>
        <span style={{
          cursor: 'pointer',
          textDecoration: 'underline'
        }}>
          REPLY
        </span>
      </Box>
    </Box>
  )
}